<template>
    <div class="flex my-3 --green" v-if="data.total && isNextPageAvailable">
        <small class="white-text" v-intersect="onIntersect" >
            Loading more...
            <v-progress-circular class="ml-2" indeterminate size="13" width="2"></v-progress-circular>
        </small>
    </div>
</template>

<script>
export default {
    name : 'infiniteScroll',

    props : {
        data : {
            type : Object,
        }
    },

    computed : {
        isNextPageAvailable() {
            const totalPages = Math.ceil(this.data.total/this.data.perPage);
            if(this.data.page >= totalPages)
                return false;
            return true;
        }
    },

    methods : {
        onIntersect(entries) {
            entries.forEach(entry => {
                console.log("ENTRY", entry);
                if(entry.isIntersecting) {
                    if(this.isNextPageAvailable)
                        this.$emit('appendList')
                }
            })
        }
    }
}
</script>